// Primarily used for post-processing Algolia search results and other client-rendered content.
// Server-side mirror: modules/fanuc/twig/ProductNameTwigExtension.php
const EM = '<em class="italic-i">i</em>';

// Keep in sync with ProductNameTwigExtension::PRODUCT_SEARCH / PRODUCT_REPLACE
const PRODUCT_SEARCH = [
  'iHMI',
  'iB5',
  'iPendant',
  'DDR-HSiB',
  'DDR-TiB',
  'DDRiB',
  'iPC',
  'Panel i',
  'MT-LINK i',
  'Manual Guide i',
  'Power Motion i',
  'iRVision',
  'iRPickTool',
  'iRCalibration',
];

const PRODUCT_REPLACE = [
  EM + 'HMI',
  EM + 'B5',
  EM + 'Pendant',
  'DDR-HS' + EM + 'B',
  'DDR-T' + EM + 'B',
  'DDR' + EM + 'B',
  EM + 'PC',
  'Panel ' + EM,
  'MT-LINK ' + EM,
  'Manual Guide ' + EM,
  'Power Motion ' + EM,
  EM + 'RVision',
  EM + 'RPickTool',
  EM + 'RCalibration',
];

function transformText(text) {
  let result = text.replace(/([0-9])i/g, '$1' + EM);
  for (let i = 0; i < PRODUCT_SEARCH.length; i++) {
    result = result.replaceAll(PRODUCT_SEARCH[i], PRODUCT_REPLACE[i]);
  }
  return result;
}

window.applyItalicI = function () {
  // .js-apply-italic-i is added to client-rendered elements (Algolia widgets, search results)
  const fanucis = document.querySelectorAll('.js-apply-italic-i');
  fanucis.forEach((fanuci) => {
    if (!fanuci.dataset.italicApplied) {
      const walker = document.createTreeWalker(fanuci, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);

      textNodes.forEach((node) => {
        const original = node.textContent;
        const replaced = transformText(original);
        if (replaced !== original) {
          const fragment = document
            .createRange()
            .createContextualFragment(replaced);
          node.replaceWith(fragment);
        }
      });

      fanuci.dataset.italicApplied = 'true';
    }
  });
};

// Run once on page load
document.addEventListener('DOMContentLoaded', () => {
  window.applyItalicI();
});

// Use MutationObserver (Only for New Elements, Not Every Change)
const observer = new MutationObserver(() => {
  setTimeout(() => {
    if (typeof window.applyItalicI === 'function') {
      window.applyItalicI();
    }
  }, 50);
});

observer.observe(document.body, { childList: true, subtree: true });
